/* tslint:disable */
import {
  UserProfile
} from '../index';

declare var Object: any;
export interface LandlordDetailsInterface {
  "start_date"?: Date;
  "end_date"?: Date;
  "dob"?: Date;
  "id"?: number;
  "land_lord_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  land_lord?: UserProfile;
}

export class LandlordDetails implements LandlordDetailsInterface {
  "start_date": Date;
  "end_date": Date;
  "dob": Date;
  "id": number;
  "land_lord_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  land_lord: UserProfile;
  constructor(data?: LandlordDetailsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LandlordDetails`.
   */
  public static getModelName() {
    return "LandlordDetails";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LandlordDetails for dynamic purposes.
  **/
  public static factory(data: LandlordDetailsInterface): LandlordDetails{
    return new LandlordDetails(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LandlordDetails',
      plural: 'LandlordDetails',
      path: 'LandlordDetails',
      idName: 'id',
      properties: {
        "start_date": {
          name: 'start_date',
          type: 'Date'
        },
        "end_date": {
          name: 'end_date',
          type: 'Date'
        },
        "dob": {
          name: 'dob',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "land_lord_id": {
          name: 'land_lord_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        land_lord: {
          name: 'land_lord',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'land_lord_id',
          keyTo: 'id'
        },
      }
    }
  }
}
